// extracted by mini-css-extract-plugin
export var searchBtn = "SearchButton-module--search-btn--3FwR4";